import { render, staticRenderFns } from "./SubmitApp.vue?vue&type=template&id=73155c80&scoped=true&"
import script from "./SubmitApp.vue?vue&type=script&lang=js&"
export * from "./SubmitApp.vue?vue&type=script&lang=js&"
import style0 from "./SubmitApp.vue?vue&type=style&index=0&id=73155c80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73155c80",
  null
  
)

export default component.exports